export enum CustomerOrderUrlParams {
  CUSTOMER_ORDER_TYPE = 'customerOrderType',
  PRODUCT_TYPE = 'productType',
}

// Browser filter names; the loader maps status and orderType to the API's state and orderType.
export enum CocoOrderUrlParams {
  ORDER_DATE_FROM = 'dateFrom',
  ORDER_DATE_TO = 'dateTo',
  PRODUCT_TYPE = 'productType',
  ORDER_TYPE = 'orderType',
  ORDER_STATUS = 'state',
}
